// Libs
import React from 'react';
import { Modal, Form } from 'react-bootstrap';
import ExpandingTextArea from 'react-expanding-textarea';
import Select from 'react-select';

// Services & Helpers
import BookingService from 'services/BookingService';
import BootboxHelper from 'helpers/BootboxHelper';
import SupportService from 'services/SupportService';

// Components
import Loader from 'components/common/Loader';

//-------------------------------------------------------------------------------------------------------------------

class EmergencyModal extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            isOpen: false,
            isLoading: true
        };
    }

    show(opts) {
        return new Promise((resolve, reject) => {
            this.opts = opts;
            this.setState({
                isOpen: true,
                isLoading: true,
                bookingID: null,
                type: null,
                description: null
            }, () => {
                this.load();
            });
        });
    }

    async load() {
        const bookings = await BookingService.list({
            includeNonATP: true
        });
        this.setState({
            bookings,
            isLoading: false
        });
    }

    close() {
        this.setState({ isOpen: false });
    }

    async submit() {
        switch (this.state.type) {
            case 'sickness':
                this.submitSickness();
                break;
            case 'webex':
                this.submitWebex();
                break;
        }
    }

    async submitSickness() {
        this.setState({ isLoading: true });
        await SupportService.emergencySickness(this.state.bookingID);
        this.close();
        BootboxHelper.alert('Thank you for contacting us. We will get back to you as soon as possible.');
    }

    async submitWebex() {
        this.setState({ isLoading: true });
        await SupportService.emergencyWebex(this.state.bookingID, this.state.description);
        this.close();
        BootboxHelper.alert('Thank you for contacting us. We will get back to you as soon as possible.');
    }

    render() {
        const { isOpen, isLoading } = this.state;
        if (!isOpen) {
            return null;
        }

        return (
            <Modal show className="emergency-modal">
                <div className="modal-header">
                    <h5>Report an urgent booking issue</h5>
                </div>
                <form onSubmit={e => { e.preventDefault(); this.saveAndClose() }}>
                    <Modal.Body>
                        {this.renderInner()}
                    </Modal.Body>
                    {!isLoading &&
                        <Modal.Footer>
                            <button type="button" className="btn btn-secondary me-auto" onClick={() => this.close()}>
                                Cancel
                            </button>
                            <button type="button" className="btn btn-primary ms-auto" onClick={() => this.submit()}>
                                Submit
                            </button>
                        </Modal.Footer>
                    }
                </form>
            </Modal>
        );
    }
    
    renderInner() {
        const {
            isLoading,
            bookings,
            type,
            bookingID,
            bookingLMSID,
            description
        } = this.state;

        if (isLoading) {
            return (<Loader />);
        }

        switch (type) {
            case 'sickness':

                return (<>
                    <p><b>LMS ID</b>: {bookingLMSID}</p>
                    <p>Please press <b>Submit</b> to confirm that you are unable to take this class due to sickness.</p>
                </>);

            case 'webex':

                return (<>
                    <p><b>LMS ID</b>: {bookingLMSID}</p>
                    <p>Please describe the problem you are having with WebEx:</p>

                    <ExpandingTextArea
                        className="form-control"
                        autoFocus
                        value={description || ''}
                        onChange={e => this.setState({ description: e.target.value })}
                        rows={3}
                    />
                </>);

                break;

            default:

                return (<>

                    {bookings.length > 0 ?
                        <Form.Group className="">
                            <Form.Label>Please select a booking</Form.Label>
                            <Select
                                className="react-select-container"
                                classNamePrefix="react-select"
                                value={bookings.find(b => b.id == bookingID)}
                                options={bookings}
                                getOptionValue={b => b.id}
                                getOptionLabel={b => b.lmsid}
                                onChange={b => this.setState({
                                    bookingID: b.id,
                                    bookingLMSID: b.lmsid
                                })}
                            />
                        </Form.Group> :
                        <p className="empty-text">
                            You have no current bookings
                        </p>
                    }

                    {!!bookingID &&
                        <Form.Group className="mt-3">
                            <Form.Label>What is the problem?</Form.Label>

                            <div className="btn-stack w-100">

                                <button button="button" className="btn btn-primary" onClick={() => this.setState({ type: 'sickness' })}>
                                    Sickness - I am unable to take my class
                                </button>

                                <button button="button" className="btn btn-primary" onClick={() => this.setState({ type: 'webex' })}>
                                    WebEx - I am having a problem
                                </button>

                            </div>
                        </Form.Group>
                    }

                </>);
        }

    }
    
}

export default EmergencyModal;